import { TReduxActions } from '../../../types/redux';
import { ENewQuestionForm, EQuestionTextTypes } from '../../../actions/newQuestion';

export const defaultValue = '';

export function textReducer(state: string = defaultValue, { type, payload }: TReduxActions): string {
  if (type === EQuestionTextTypes.Set) {
    return payload;
  }

  if (type === ENewQuestionForm.Clear) {
    return defaultValue;
  }

  return state;
}
